import {
    LEARNING_CENTER_ROUTE,
    MEDICARE_BASICS_ROUTE,
    PLANS_ROUTE
} from 'utilities/routes';

const data = [
    {
        title: 'Plans',
        navigationLink: PLANS_ROUTE
    },
    {
        title: 'Introduction to Medicare',
        navigationLink: MEDICARE_BASICS_ROUTE
    },
    { title: 'Learning Center', navigationLink: LEARNING_CENTER_ROUTE }
];

export default data;
